export default __webpack_public_path__ + "static/fullWidth2-995c14e0e4218b35693ea5477b33f65e.png";